import React from "react"
import { notifications } from "@mantine/notifications"
import { useMantineTheme } from "@mantine/core"
import { Icon } from "@/components/Icon"

const useNotification = () => {
    const theme = useMantineTheme()

    return {
        feedbackReceived: () => {
            notifications.show({
                id: "personalized-summary-saved",
                title: "Feedback submitted",
                message: "Thanks for your feedback!",
                autoClose: true,
                withCloseButton: true,
                color: "green.0",
                icon: <Icon icon="thumbs-up" color={theme.colors.green[6]} />,
            })
        },
    }
}

export default useNotification
